<!--
Author: TangChen
Date: 2018-12-8
Desc: 购买基金，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-buy-fund bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/fund' }">
                    基金交易
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <!--购买逻辑全在该组件内-->
        <buy-comp ref="buyComp" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import buyComp from "@/components/fund/buyComp";
export default {
    name: "BuyFund",
    components: {
        buyComp
    },
    mixins: [mixin],
    data () {
        return {
        };
    },
    mounted () {
    },
    methods: {
    }
};
</script>
